import React, { useEffect, useState } from 'react';

import { Link } from 'core/components';
import { getHashForObject } from 'app/stores/query/urlHash';
import makeCancelable, { CanceledError } from 'core/util/cancelablePromise';

// prevent refetching when used in virtualized tables
const hashCache = {};

async function getHashForFilters(key, filters) {
  if (hashCache[key]) {
    return hashCache[key];
  }

  return getHashForObject({ hashedFilters: filters }).then((hash) => {
    hashCache[key] = hash;
    return hash;
  });
}

const FilteredDevicesLink = ({ filters, children, ...rest }) => {
  const [hash, setHash] = useState(null);
  const key = JSON.stringify(filters);

  useEffect(() => {
    if (filters) {
      const hashRequest = makeCancelable(getHashForFilters(key, filters));

      hashRequest.promise
        .then((_hash) => {
          setHash(_hash);
        })
        .catch((error) => {
          if (!(error instanceof CanceledError)) {
            throw error;
          }
        });

      return () => {
        hashRequest.cancel();
      };
    }

    return undefined; // needed to satisfy linter
  }, [filters, key]);

  return (
    <Link to={`/v4/infrastructure/devices${hash ? `/?q=${hash}` : ''}`} {...rest}>
      {children}
    </Link>
  );
};

export default FilteredDevicesLink;
